<div class="k-hbox">
  <div class="align-bottom me-2">{{ AccountInfo?.name }}</div>
  <div class="align-bottom me-2">({{ AccountInfo?.username }})</div>
  <kendo-avatar
    shape="circle"
  ></kendo-avatar>
</div>
